export default __webpack_public_path__ + "static/media/icon_apple_pay.fd67d15e.png";